import { createContext, useContext } from 'react';
import { NO_COMPARE, compareLabels } from '../utils/periods';

/**
 * Textos da comparação em uso (nenhuma, período anterior ou mesmo período
 * do ano passado), para os gráficos e indicadores nomearem a série comparada sem
 * cada seção repassar o período. Ver compareLabels.
 */
export const StatsCompareContext = createContext(compareLabels({ compare: NO_COMPARE }));

export const useStatsCompare = () => useContext(StatsCompareContext);
